import type {CreateOfferTemplateFormPayload} from "./create-offer-template.schema";
import {createOfferTemplate} from "@project/sdk/sales";
import {CreateOfferTemplateResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {offerTemplateKeys, offerTemplateMutationKeys} from "../../../offerTemplate-keys";
import {createOfferTemplateFormSchema} from "./create-offer-template.schema";

export function createOfferTemplateMutationOptions() {
  return mutationOptions({
    mutationKey: offerTemplateMutationKeys.createOfferTemplate,
    mutationFn: async (payload: CreateOfferTemplateFormPayload) =>
      CreateOfferTemplateResponse.parse(
        await createOfferTemplate(createOfferTemplateFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: offerTemplateKeys.lists()});
    },
  });
}
